import React from 'react';
import TurnitinModal from '../../TurnitinModal';
import { ExtensionAssignment, ExtensionUser } from './ManageExtension.types';

type Props = {
  assignment: ExtensionAssignment;
  onClose: () => void;
  spaceId: string;
  user: ExtensionUser;
};

const TurnitinExtensionModal = ({
  assignment,
  onClose,
  spaceId,
  user,
}: Props) => (
  <TurnitinModal
    assignment={{
      ...assignment,
      objectId: assignment.objectId || assignment.id,
      description: assignment.description ?? '',
      endDate: assignment.endDate ?? '',
      startDate: assignment.startDate ?? '',
      gradesReleasedAt: assignment.gradesReleasedAt ?? '',
    }}
    user={user}
    space={{ objectId: spaceId }}
    onClose={onClose}
  />
);

export default TurnitinExtensionModal;
